"use client";
import Link from "next/link";
import { ArrowRight, Clock } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { interview as data } from "@/lib/data/careers";

const accent = "var(--color-emerald)";

export function Interview() {
  return (
    <Section id="how-to-apply" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 relative">
          <div className="hidden lg:block absolute top-0 bottom-0 left-[27px] w-px" style={{ background: `linear-gradient(180deg, transparent, color-mix(in oklch, ${accent} 50%, transparent) 10%, color-mix(in oklch, var(--color-cyan) 50%, transparent) 50%, color-mix(in oklch, var(--color-purple) 50%, transparent) 90%, transparent)` }} aria-hidden />
          <div className="space-y-8">
            {data.stages.map((stage, i) => {
              const colors = ["var(--color-emerald)", "var(--color-cyan)", "var(--color-purple)", "var(--color-amber)", "var(--color-crimson)"];
              const c = colors[i % colors.length]!;
              return (
                <Reveal key={stage.stage} delay={i * 100}>
                  <div className="relative flex gap-6 items-start">
                    <div className="shrink-0 relative">
                      <div className="grid place-items-center h-14 w-14 rounded-2xl glass relative z-10" style={{ boxShadow: `0 0 0 4px rgb(var(--bg)), inset 0 0 0 1px color-mix(in oklch, ${c} 35%, transparent)` }}>
                        <span className="text-xs font-bold tracking-wider" style={{ color: c }}>{stage.stage.split(" ")[1]}</span>
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <div className="eyebrow-tiny" style={{ color: c }}>{stage.stage}</div>
                      <h3 className="mt-1">{stage.title}</h3>
                      <p className="mt-3 text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed max-w-2xl">{stage.body}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
        <Reveal delay={500}>
          <div className="mt-10 glass rounded-2xl p-6">
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-10 w-10 rounded-xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                <Clock className="h-4 w-4" style={{ color: accent }} />
              </span>
              <h3 className="text-base font-bold">Timeline</h3>
            </div>
            <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.timeline[0]?.label} {data.timeline[0]?.body}</p>
          </div>
        </Reveal>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
